export default "__VITE_ASSET__531BLk5n__"